'use client';

import colors from '../colors';
import { buildGet } from '../../utils/typography/get';
import { buildTypes } from '../../utils/typography/types';
import buildClasses from '../../utils/typography/buildClasses';
export const family = {
  opensans: '"Open Sans", sans-serif, Tahoma, Arial',
  roboto: 'Roboto, San Francisco, Helvetica Neue, Helvetica, Arial, sans-serif'
};
export const weight = {
  extraBold: '800',
  bold: '700',
  semiBold: '600',
  medium: '500',
  light: '400',
  regular: '400'
};
export const lineHeights = {
  base: 1.5,
  large: 1.5,
  small: 1.2,
  headings: 1,
  badge: 1,
  button: '2em',
  computed: `${Math.floor(1.5 * 14)}px`
};
export const config = {
  '3XL': {
    lineHeight: lineHeights.headings,
    color: colors.neutral.black,
    fontFamily: family.roboto,
    fontSize: '32px',
    fontWeight: weight.bold,
    letterSpacing: '0',
    textTransform: 'capitalize'
  },
  '2XL': {
    lineHeight: lineHeights.headings,
    color: colors.neutral.black,
    fontFamily: family.roboto,
    fontSize: '32px',
    fontWeight: weight.regular,
    letterSpacing: '0',
    textTransform: 'capitalize'
  },
  XL: {
    lineHeight: lineHeights.headings,
    color: colors.neutral.black,
    fontFamily: family.roboto,
    fontSize: '24px',
    fontWeight: weight.bold,
    letterSpacing: '0',
    textTransform: 'none'
  },
  large: {
    lineHeight: lineHeights.headings,
    color: colors.neutral.black,
    fontFamily: family.roboto,
    fontSize: '24px',
    fontWeight: weight.regular,
    letterSpacing: '0',
    textTransform: 'capitalize'
  },
  MExtra: {
    lineHeight: lineHeights.headings,
    color: colors.neutral.black,
    fontFamily: family.roboto,
    fontSize: '18px',
    fontWeight: weight.bold,
    letterSpacing: '0',
    textTransform: 'capitalize'
  },
  MSemi: {
    lineHeight: lineHeights.headings,
    color: colors.neutral.black,
    fontFamily: family.roboto,
    fontSize: '18px',
    fontWeight: weight.regular,
    letterSpacing: '0',
    textTransform: 'capitalize'
  },
  SExtra: {
    lineHeight: lineHeights.headings,
    color: colors.neutral.black,
    fontFamily: family.roboto,
    fontSize: '16px',
    fontWeight: weight.bold,
    letterSpacing: '0',
    textTransform: 'capitalize'
  },
  SSemi: {
    lineHeight: lineHeights.headings,
    color: colors.neutral.black,
    fontFamily: family.roboto,
    fontSize: '16px',
    fontWeight: weight.regular,
    letterSpacing: '0',
    textTransform: 'capitalize'
  },
  XSExtra: {
    lineHeight: lineHeights.headings,
    color: colors.neutral.black,
    fontFamily: family.roboto,
    fontSize: '14px',
    fontWeight: weight.bold,
    letterSpacing: '0.5px',
    textTransform: 'none'
  },
  XSSemi: {
    lineHeight: lineHeights.headings,
    color: colors.neutral.black,
    fontFamily: family.roboto,
    fontSize: '14px',
    fontWeight: weight.bold,
    letterSpacing: '0.5px',
    textTransform: 'none'
  },
  bodyXL: {
    lineHeight: lineHeights.base,
    color: colors.neutral.black,
    fontFamily: family.roboto,
    fontSize: '16px',
    fontWeight: weight.regular,
    letterSpacing: '0',
    textTransform: 'none'
  },
  bodyL: {
    lineHeight: lineHeights.base,
    color: colors.neutral.black,
    fontFamily: family.roboto,
    fontSize: '14px',
    fontWeight: weight.bold,
    letterSpacing: '0',
    textTransform: 'none'
  },
  body: {
    lineHeight: lineHeights.base,
    color: colors.neutral.black,
    fontFamily: family.roboto,
    fontSize: '14px',
    fontWeight: weight.regular,
    letterSpacing: '0',
    textTransform: 'none'
  },
  bodyWide: {
    lineHeight: lineHeights.base,
    color: colors.neutral.black,
    fontFamily: family.roboto,
    fontSize: '12px',
    fontWeight: weight.bold,
    letterSpacing: '0',
    textTransform: 'none'
  },
  bodyTight: {
    lineHeight: lineHeights.base,
    color: colors.neutral.black,
    fontFamily: family.roboto,
    fontSize: '12px',
    fontWeight: weight.regular,
    letterSpacing: '0',
    textTransform: 'none'
  },
  body12: {
    lineHeight: lineHeights.base,
    color: colors.neutral.black,
    fontFamily: family.roboto,
    fontSize: '12px',
    fontWeight: weight.bold,
    letterSpacing: '0',
    textTransform: 'none'
  },
  bodySmall: {
    lineHeight: lineHeights.base,
    color: colors.neutral.black,
    fontFamily: family.roboto,
    fontSize: '12px',
    fontWeight: weight.regular,
    letterSpacing: '0',
    textTransform: 'none'
  },
  SpecialXSExtra: {
    lineHeight: lineHeights.base,
    color: colors.neutral.black,
    fontFamily: family.roboto,
    fontSize: '10px',
    fontWeight: weight.regular,
    letterSpacing: '0',
    textTransform: 'none'
  },
  SpecialXSSemi: {
    lineHeight: lineHeights.base,
    color: colors.neutral.black,
    fontFamily: family.roboto,
    fontSize: '10px',
    fontWeight: weight.regular,
    letterSpacing: '0',
    textTransform: 'none'
  }
};
export const lineHeightDefaults = Object.keys(config).reduce((acc, key) => ({
  ...acc,
  [key]: `line-height: ${config[key].lineHeight};`
}), {});
export const fontColorDefaults = Object.keys(config).reduce((acc, key) => ({
  ...acc,
  [key]: `color: ${config[key].color};`
}), {});
export const styles = buildClasses(config);
export const defaults = buildTypes(config, false, false);
export const types = buildTypes(config, true, true);
export const get = buildGet(config);
//# sourceMappingURL=typography.js.map